// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const saltDeposit = defineModel({
  id: "salt-deposit",
  batchId: "future",
  name: "Salt deposit",
  tags: ["scenery","salt","deposit","low-poly","age-of-mcp","future"],
  summary: "A crust of rock salt. Preserves food, cures hides and seasons.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.44,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.34, 0.42, 0.12, 8), color: "#e6dede", position: [0, 0.06, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.22, 0), color: "#d7cccc", position: [0.05, 0.12, -0.04], rotation: [0.1, 0.4, 0], scale: [1.1, 0.6, 1.05] },
      { geometry: new THREE.BoxGeometry(0.16, 0.16, 0.16), color: "#f0e7e7", position: [0, 0.18, 0.04], rotation: [0.15, 0.4, 0.1] },
      { geometry: new THREE.BoxGeometry(0.12, 0.12, 0.12), color: "#e9c9cf", position: [0.16, 0.16, 0.1], rotation: [0.1, 0.7, 0.2] },
      { geometry: new THREE.BoxGeometry(0.13, 0.13, 0.13), color: "#f0e7e7", position: [-0.14, 0.15, 0.08], rotation: [0.2, 1.1, 0.1] },
      { geometry: new THREE.BoxGeometry(0.1, 0.1, 0.1), color: "#f4d8dd", position: [0.06, 0.3, -0.02], rotation: [0.3, 0.5, 0.2] },
      { geometry: new THREE.BoxGeometry(0.09, 0.09, 0.09), color: "#f0e7e7", position: [-0.08, 0.28, -0.1], rotation: [0.1, 0.9, 0.15] },
      { geometry: new THREE.BoxGeometry(0.08, 0.08, 0.08), color: "#e9c9cf", position: [0.14, 0.26, -0.08], rotation: [0.2, 0.3, 0.25] },
      { geometry: new THREE.BoxGeometry(0.07, 0.07, 0.07), color: "#f4d8dd", position: [0.04, 0.34, 0], rotation: [0.25, 0.6, 0.1] },
      { geometry: new THREE.BoxGeometry(0.07, 0.07, 0.07), color: "#f0e7e7", position: [0.3, 0.04, 0.16], rotation: [0.3, 0.5, 0.2] },
      { geometry: new THREE.BoxGeometry(0.06, 0.06, 0.06), color: "#e9c9cf", position: [-0.3, 0.035, -0.1], rotation: [0.2, 0.9, 0.3] },
      { geometry: new THREE.BoxGeometry(0.055, 0.055, 0.055), color: "#f0e7e7", position: [0.08, 0.03, -0.32], rotation: [0.25, 0.4, 0.2] },
    ],
  animations: [],
});
